import { useLayoutEffect } from "react";

import { useTranslation } from "lib/i18n/use-translation";
import { getPersonName } from "lib/toc/person-name";
import { useToc } from "lib/toc/use-toc";

export function Head() {
  const { t } = useTranslation();
  const { toc } = useToc();

  const author = toc?.Meta.Authors?.find(a => a.Role === "author");
  const fullName = author ? getPersonName(author) : t("Неизвестный автор");
  const bookTitle = toc?.Meta.Title || t("Без названия");

  let description = `${bookTitle} ${t("от")} ${fullName}`;

  const translator = toc?.Meta.Translators?.[0];
  if (translator) {
    description += ` (${t("перевод")} ${getPersonName(translator)})`;
  }

  const writtenDate = toc?.Meta.Written?.Date;
  if (writtenDate) {
    const year = new Date(writtenDate).getFullYear();
    if (!isNaN(year)) {
      description += `, ${year}`;
    }
  }

  const seriesRelation = toc?.Meta.Relations?.find(r => r.type === "series");
  if (seriesRelation) {
    description += ` - ${t("из серии")} "${seriesRelation.title}"`;
  }

  const bookLang = toc?.Meta.Lang;

  useLayoutEffect(() => {
    if (bookLang) {
      document.documentElement.lang = bookLang;
    }
    document.title = `${fullName} - ${bookTitle}`;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", description);

    let metaAuthor = document.querySelector('meta[name="author"]');
    if (!metaAuthor) {
      metaAuthor = document.createElement("meta");
      metaAuthor.setAttribute("name", "author");
      document.head.appendChild(metaAuthor);
    }
    metaAuthor.setAttribute("content", fullName);

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute("content", bookTitle);

    let ogDescription = document.querySelector(
      'meta[property="og:description"]'
    );
    if (!ogDescription) {
      ogDescription = document.createElement("meta");
      ogDescription.setAttribute("property", "og:description");
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute("content", description);
  }, [fullName, bookTitle, description, bookLang, t]);

  return null;
}
